import React, { useEffect } from 'react';
import { AlertHeader } from '../components/sales/AlertHeader';
import { HeroSection } from '../components/sales/HeroSection';
import { LeadSection } from '../components/sales/LeadSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { ProductShowcase } from '../components/sales/ProductShowcase';
import { BonusesSection } from '../components/sales/BonusesSection';
import { OfferSection } from '../components/sales/OfferSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { FAQSection } from '../components/sales/FAQSection';
import { StickyFooter } from '../components/sales/StickyFooter';
export function SalesPage() {
  useEffect(() => {
    // Fire Meta Pixel PageView on mount
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20 md:pb-0" data-id="element-300">
      <AlertHeader data-id="element-301" />
      <HeroSection data-id="element-302" />
      <LeadSection data-id="element-303" />
      <BenefitsSection data-id="element-304" />
      <ProductShowcase data-id="element-305" />
      <BonusesSection data-id="element-306" />
      <OfferSection data-id="element-307" />
      <TestimonialsSection data-id="element-308" />
      <FAQSection data-id="element-309" />

      <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm" data-id="element-310">
        <div className="max-w-4xl mx-auto" data-id="element-311">
          <p className="mb-4" data-id="element-312">
            Este producto no sustituye el parecer de un médico profesional.
            Siempre consulte a un médico para tratar asuntos de salud.
          </p>
          <p data-id="element-313">
            &copy; {new Date().getFullYear()} Protocolo de Limpieza Glicémica.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <StickyFooter data-id="element-314" />
    </div>;
}